// extracted by mini-css-extract-plugin
export var htmlPreview = "_qg-2";
export var modal = "_qg-0";
export var sidebar = "_qg-1";